import Button from '@/atoms/Button';
import * as Dialog from '@radix-ui/react-dialog';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { ModalFooterProps } from '../views/types';

const ModalFooter = ({
  onSubmit,
  alert = false,
  submitLabel,
  isLoadingContent,
  isSubmitDisabled,
  isLoading,
}: ModalFooterProps) => {
  const { t } = useTranslation();

  const defaultSubmitLabel = alert ? 'close' : 'validate';

  return (
    <div className="flex flex-col md:flex-row p-4 gap-3">
      <Dialog.DialogClose asChild>
        <Button
          className={clx('grow', isLoadingContent && 'animate-loadingModal')}
          disabled={isSubmitDisabled}
          icon={isLoading ? 'animate-spin fa-thin fa-spinner-third' : undefined}
          isLoading={isLoading || isLoadingContent}
          onClick={isLoadingContent ? undefined : onSubmit}
          type="button"
        >
          {t(submitLabel || defaultSubmitLabel)}
        </Button>
      </Dialog.DialogClose>
    </div>
  );
};

export default ModalFooter;
